module.exports = __webpack_public_path__ + "img/index-bottom.74d41752.png";